import React from 'react';

const Footer = () => {
  return (
    <footer className="stt-footer">
      <p style={{ margin: '0 0 4px' }}>© {new Date().getFullYear()} Southie Totus Tuus</p>
      <p style={{ margin: 0 }}>A Gate of Heaven &amp; St. Brigid Young Adults Community</p>
      <p style={{ margin: '8px 0 0' }}>
        <a href="/login" style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.72rem' }}>Login</a>
      </p>
    </footer>
  );
};

export default Footer;
